<template>
  <t-dropdown
    :max-column-width="400"
    :min-column-width="160"
    trigger="hover"
    placement="bottom"
    :options="dropdownOptions"
    @click="(option) => jumpToWbpPage(option as unknown as WbpTodoMenuItem)"
  >
    <t-badge :count="totalCount" :max-count="99">
      <t-button theme="default" variant="text" class="wbp-switch cursor-pointer" @click="jumpToWbp">
        {{ $t('处理及查看') }}
        <span class="text-blue-700">{{ $t('WBP') }}</span>
        {{ $t('待办') }}
      </t-button>
    </t-badge>
  </t-dropdown>
</template>

<script setup lang="tsx">
import { ref, computed, onMounted } from 'vue';
import { getWbpDomain, WBP_MENU_CONFIG, WbpTodoMenuItem } from './config';
import { workflowClient } from 'iegsp-api/git.woa.com/itrpcprotocol/iegsp/suppliercgi/workflow/workflow.http';
import type { MenuOptions } from 'iegsp-api/git.woa.com/itrpcprotocol/iegsp/suppliercgi/workflow/workflow';

const todoData = ref<Record<string, number>>({});
const totalCount = ref<number>(0);

const visibleMenuList = computed<WbpTodoMenuItem[]>(() =>
  WBP_MENU_CONFIG.map((item) => ({ ...item, count: todoData.value[item.key] || 0 })).filter((item) => item.count > 0),
);

const wbpDomain = computed<string>(() => getWbpDomain());

const dropdownOptions = computed(() =>
  visibleMenuList.value.map((item) => ({
    content: () => (
      <div class="flex items-center justify-between gap-16 w-full">
        <span>{item.label}</span>
        <t-badge class="wbp-todo-badge-static" count={item.count} max-count={99} />
      </div>
    ),
    value: item.key,
    ...item,
  })),
);

const jumpToWbp = (): void => {
  window.open(wbpDomain.value, '_blank');
};

const jumpToWbpPage = (option: WbpTodoMenuItem): void => {
  window.open(`${wbpDomain.value}${option.path}`, '_blank');
};

const fetchWbpTodoCount = (): void => {
  workflowClient.GetWbpTodoCount({}).then(([res]) => {
    // total 与 count 后端返回均为 string，需要转换为 number 用于 t-badge 展示
    totalCount.value = Number(res?.total) || 0;
    // menu_count 是数组结构，转换为 { [key]: number } 便于按 key 查找
    const menuCount: Record<string, number> = {};
    (res?.menu_count || []).forEach((item: MenuOptions) => {
      if (item.key) {
        menuCount[item.key] = Number(item.count) || 0;
      }
    });
    todoData.value = menuCount;
  });
};

onMounted(() => {
  fetchWbpTodoCount();
});
</script>

<style lang="less" scoped>
.wbp-switch {
  font-size: 14px;
  white-space: nowrap;
  padding: 0 12px;
}

:deep(.t-badge--circle) {
  transform: translate(-2px, -10px);
}

/* 下拉菜单 panel 被 teleport 到 body，无 scoped hash，需用 :global() 跳出 scoped 作用域；
 * 同时通过 `.t-dropdown__menu` 收窄作用范围，避免污染其他场景 */
:global(.t-dropdown__menu .wbp-todo-badge-static) {
  display: flex;
  align-items: center;
  position: static;
}

:global(.t-dropdown__menu .wbp-todo-badge-static .t-badge--circle),
:global(.t-dropdown__menu .wbp-todo-badge-static .t-badge--round) {
  position: static;
  transform: none;
}
</style>
